module.exports = __webpack_public_path__ + "components/rewards-header/static/unlock-white-4af75bda29ebc3f4d971f501d46c1205.svg";